import memoize from 'lodash.memoize';
import { type VirtualKeyboard } from './virtualKeyboard.type';

export type BrowserFeature = {
  virtualKeyboard: VirtualKeyboard | undefined;
};

type Navigator = globalThis.Navigator &
  Record<'virtualKeyboard', VirtualKeyboard>;

const getBrowserFeatureImpl = (): BrowserFeature => ({
  virtualKeyboard:
    'navigator' in globalThis && 'virtualKeyboard' in globalThis.navigator
      ? (globalThis.navigator as Navigator).virtualKeyboard
      : undefined,
});

const createGetBrowserFeature = (): (() => BrowserFeature) => {
  return memoize(getBrowserFeatureImpl);
};

/**
 * Returns an object containing the presence of various browser features.
 * The result is memoized to improve performance.
 *
 * @returns {BrowserFeature} An object with a record of features and boolean values indicating the presence of specific browser features.
 * @example
 * {
 *   virtualKeyboard: true
 * }
 */
export const getBrowserFeature = createGetBrowserFeature();
